import AutoComplete from './AutoComplete';

// export types
export type { AutoCompleteProps } from './AutoComplete';

// export components
export { AutoComplete };
export default AutoComplete;
